import React from 'react';
import PropTypes from 'prop-types';
import { trans, getPagePath } from '@spotahome/bff/client';
import { Header, Button, MenuIcon } from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/Header.css';
import '@spotahome/ui-library/lib/components/Button.css';
import '@spotahome/ui-library/lib/components/MenuIcon.css';

import LanguageSwitcherContainer from './LanguageSwitcher';
import LogoLink from './LogoLink';
import LoginButton from './login/LoginButton';

const DesktopHeader = ({ onClickMenu }) => (
  <Header
    color="transparent"
    logo={
      <LogoLink
        link={getPagePath('externals.landing-pages.home')}
        color="light"
      />
    }
    menuIcon={<MenuIcon onMenuClick={onClickMenu} color="light" />}
  >
    <Header.Nav>
      <Header.Item>
        <Button
          href={getPagePath('externals.landing-pages.list-your-property')}
          className="ga-home-publish-your-property-top"
          color="filled"
        >
          {trans('landingpage.button.landlord')}
        </Button>
      </Header.Item>

      <Header.Item>
        <Header.Link
          color="light"
          href={getPagePath('externals.landing-pages.how-it-works')}
          target="_blank"
          className="ga-menu-faqs"
        >
          {trans('how_it_works.title')}
        </Header.Link>
      </Header.Item>

      <Header.Item>
        <Header.Link
          color="light"
          className="ga-menu-favorites"
          href={getPagePath('externals.marketplace.favorites')}
          target="_blank"
        >
          {trans('favorites.title.favorites')}
        </Header.Link>
      </Header.Item>

      <LoginButton />

      <Header.Item>
        <Header.Link
          color="light"
          href={getPagePath('externals.landing-pages.help-center')}
        >
          {trans('help.title')}
        </Header.Link>
      </Header.Item>

      <Header.Item>
        <Header.Link color="light">
          <LanguageSwitcherContainer abbreviated />
        </Header.Link>
      </Header.Item>
    </Header.Nav>
  </Header>
);

DesktopHeader.defaultProps = {
  onClickMenu: () => {}
};

DesktopHeader.propTypes = {
  onClickMenu: PropTypes.func
};

export default DesktopHeader;
